import React from 'react'

import { Table } from 'antd'
import dayjs from 'dayjs'

import './ShareWithTable.css'

const datasource = [
  {
    team: 'PingCAP Tech Support',
    role: 'Owner',
    lastActivity: dayjs().subtract(1, 'hour').format('YYYY/MM/DD HH:mm:ss')
    // lastActivity: '2020/02/02 02:02:02'
  }
  // {
  //   team: 'PingCAP Tech Support with SOC2',
  //   role: 'Analyst',
  //   lastActivity: '2020/02/02 02:02:02'
  // },
  // {
  //   team: 'AskTUG Diagnoser',
  //   role: 'Analyst',
  //   lastActivity: '2020/02/02 02:02:02'
  // }
]

const columns = [
  {
    title: 'Support Teams',
    dataIndex: 'team',
    key: 'team'
  }
  // {
  //   title: 'Organization Role',
  //   dataIndex: 'role',
  //   key: 'role'
  // },
  // {
  //   title: 'Last Activity',
  //   dataIndex: 'lastActivity',
  //   key: 'lastActivity'
  // }
]

const ShareWithTable: React.FC = () => {
  return (
    <div className='share-with-table border border-solid rounded-lg overflow-hidden border-gray-200'>
      <Table
        size='small'
        columns={columns}
        dataSource={datasource}
        rowKey='team'
        pagination={false}
      />
    </div>
  )
}

export default ShareWithTable
